/**
 * OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPage
 *
 * Page component for OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPage
 * Path: /sl/docs/reference/operators
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsSLDocScreenView as __OrbDocReferenceOperatorsSLDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsSLDocScreenView';
import { OrbDocReferenceOperatorsSLDocAnalyticsView as __OrbDocReferenceOperatorsSLDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPage(_props: OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Operatorji","description":"Vsak operator, ki ga program .lolo lahko pokliče, iz kanoničnega registra, ki ga prevajalnik vgradi.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators"},{"locale":"ar","path":"/ar/docs/reference/operators"},{"locale":"sl","path":"/sl/docs/reference/operators"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsSLOrbDocReferenceOperatorsSLPage;
